import { Col, Input } from 'antd';
import React, { useEffect, useState } from 'react'
import TinyEditor from '../../../../components/atoms/formFields/tinyEditor';
import { useDispatch, useSelector } from 'react-redux';
import { resetSaveCancellation, resetSaveReturn, resetUpdateCancellation, resetUpdateReturn } from '../../../../store/slices/vendorStoreSlice';
import { ContentInputField } from '../../../../components/atoms/formFields/inputField/contentInputField';
import { isNumberOnly } from '../../../../utils/regex';

const CommonFields = ({ type, returnData, setReturnData, errors, setErrors, storeId }) => {
    const { data } = useSelector((state) => state?.returnPolicy);
    const { data: cancellation } = useSelector((state) => state?.cancellationPolicy);
    const dispatch = useDispatch();

    useEffect(() => {
        if (storeId) {
            const { id, createdDate, updatedDate, status, ...filteredData } = (type === "Cancellation" ? cancellation : data) || {};

            setReturnData({
                ...filteredData,
                inventoryId: storeId
            });
        }
        else {
            setReturnData({});
            setErrors({});
        }
        dispatch(resetSaveCancellation());
        dispatch(resetUpdateCancellation());
        dispatch(resetSaveReturn());
        dispatch(resetUpdateReturn());
    }, [data, cancellation, storeId])

    const days = `${type.toLowerCase()}EligibleDays`;
    const policy = `${type.toLowerCase()}EligiblePolicy`;

    return (
        <>
            <Col className="gutter-row" xs={24}>
                <p className="font-weight-bolder font-size-lg mb-3 h5">
                    {type} Details
                </p>
            </Col>
            <Col className="gutter-row" xs={24} lg={8}>

                <ContentInputField
                    required={true}
                    name={`Number of days eligible for ${type}`}
                    placeholder="Days"
                    errors={errors?.[days]}
                    value={returnData?.[days]}
                    style={{
                        width: "100%",
                    }}
                    onChange={(e) => {
                        setReturnData({
                            ...returnData,
                            [days]: e.target.value,
                        });
                        setErrors({
                            ...errors,
                            [days]: e.target.value ? (isNumberOnly(e.target.value) ? "" : "Invalid Days") : "Number of Days is Mandatory",
                        });
                    }}
                />
            </Col>

            <Col
                className={`gutter-row tox-editor-small ${type}Rules`}
                xs={24}
                lg={16}
            >
                <label className="font-weight-bolder font-size-sm">
                    {type === "Return" ? "Refund" : type} Rules <span className="text-danger">*</span>
                </label>
                <TinyEditor
                    className={errors?.[policy] ? "invalid" : ""}
                    value={returnData?.[policy] ?? ""}
                    func={(content, editor) => {
                        setReturnData({
                            ...returnData,
                            [policy]: content,
                        });
                        setErrors({
                            ...errors,
                            [policy]: content ? "" : `${type === "Return" ? "Refund" : type} Policy is Mandatory`,
                        });
                        content
                            ? document
                                .querySelector(`.${type}Rules .tox-tinymce`)
                                .classList.remove("invalid")
                            : document
                                .querySelector(`.${type}Rules .tox-tinymce`)
                                .classList.add("invalid");
                    }}
                />
                <small className="text-danger">
                    {errors?.[policy]}
                </small>
            </Col>
        </>
    )
}

export default CommonFields